import classNames from "classnames";
import { Icon } from "components";
import styles from "./Pickable.module.css";

interface PickableProps extends React.PropsWithChildren {
  className?: string;
  active?: boolean;
  iconSize?: string;
  style?: React.CSSProperties;
  onClick(): void;
}

const Pickable: React.FC<PickableProps> = ({
  className,
  active,
  iconSize,
  style,
  children,
  onClick,
}) => (
  <button
    className={classNames(className, styles.container, active && styles.active)}
    onClick={onClick}
    style={style}
  >
    <span className={styles.overlay} />
    {active && (
      <Icon
        name="check"
        size={iconSize}
        color="white"
        container={{ className: styles.icon, color: "#1565c0" }}
      />
    )}
    {children}
  </button>
);

export { Pickable };
